import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import BenefitsSection from "@/components/BenefitsSection";
import FloatingContact from "@/components/FloatingContact";
import LeadFormPopup from "@/components/LeadFormPopup";
import { FormPopupProvider } from "@/components/FormPopupContext";

const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const ClientTypes = lazy(() => import("@/components/ClientTypes"));
const CreditInfo = lazy(() => import("@/components/CreditInfo"));
const SimulationForm = lazy(() => import("@/components/SimulationForm"));
const TransparencySection = lazy(() => import("@/components/TransparencySection"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const Footer = lazy(() => import("@/components/Footer"));
const WelcomePopup = lazy(() => import("@/components/WelcomePopup"));

export default function LandingPage() {
  return (
    <FormPopupProvider>
      <div data-testid="landing-page" className="min-h-screen">
        <LeadFormPopup />
        <Suspense fallback={null}><WelcomePopup /></Suspense>
        <FloatingContact />
        <Navbar />
        <HeroSection />
        <BenefitsSection />
        <Suspense fallback={<div className="py-32" />}>
          <HowItWorks />
          <ClientTypes />
          <CreditInfo />
          <SimulationForm />
          <TransparencySection />
          <FinalCTA />
          <Footer />
        </Suspense>
      </div>
    </FormPopupProvider>
  );
}
